import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { SharePanelMode } from "../../Panels/CMFileSharePanel";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { Link20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/Link20Regular";
import { ComponentTypes } from "../../../src/taskpane/config/config";

export function useMenuItem_CopyLink(isCopyEnabled: boolean, openSharePanel: (mode: SharePanelMode) => void) {
  const languageStrings = React.useContext(LanguageContext);

  const tenantSharingEnabled = useSelector((state: RootState) => state.tenantInfo?.enableSharing);
  const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.at(-1));

  const menuItem_CopyLink = React.useMemo(() => {
    if (isCopyEnabled && tenantSharingEnabled && currentDirectory?.type !== ComponentTypes.SharePointList) {
      return {
        key: "copyLink",
        // iconProps: { iconName: "Link" },
        iconProps: {},
        onRenderIcon: () => <Link20Regular className={menuItemIconStyles} />,
        text: `${languageStrings.CopyLink}`,
        onClick: () => openSharePanel(SharePanelMode.Copy)
      } as IContextualMenuItem;
    }
    return null;
  }, [isCopyEnabled, tenantSharingEnabled, currentDirectory, languageStrings, openSharePanel]);

  return {
    menuItem_CopyLink
  }
}
